import { observer } from 'mobx-react-lite'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ToggleButton from '@mui/material/ToggleButton'
import { SxProps, Theme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'

interface ToggleButtonGroupCustomProps {
   options: ({ value: string, label: string } | string)[]
   buttonsxprops?: SxProps<Theme>
}

export type ToggleButtonGroupProps = React.ComponentProps<typeof ToggleButtonGroup> & ToggleButtonGroupCustomProps

export default observer(function ToggleButtonGroupCustom(props: ToggleButtonGroupProps) {
   return (
      <ToggleButtonGroup color="primary" {...props} >
         {props.options.map(option => {
            const toggleButtonProps = typeof option === 'string' ? {
               value: option,
               key: option + option.charAt(0).toUpperCase() + option.slice(1),
               label: option.charAt(0).toUpperCase() + option.slice(1)
            } : {
               value: option.value,
               key: option.value + option.label,
               label: option.label
            }

            return <ToggleButton sx={props.buttonsxprops} value={toggleButtonProps.value} key={toggleButtonProps.key}>
               <Typography variant="body1">
                  {toggleButtonProps.label}
               </Typography>
            </ToggleButton>
         })}
      </ToggleButtonGroup>
   )
})
